import { useEffect, useState, useCallback } from 'react'
import {
	IdleTimerProvider,
	useIdleTimerContext,
	workerTimers,
} from 'react-idle-timer'
import { Analytics, UserHelper } from '@Techedge/digitalportal-shared'

export default (props: any) => {
	const TAG: string =
		'------------------------------------REACT-IDLE-TIMER-PROVIDER------------------------------------'
	const STATUS = { IDLE: 'IDLE', ACTIVE: 'ACTIVE' }
	const { children, providerName } = props
	// const timeout: number = 180000000
	const timeout: number = 1800000
	const logoutTime: number = 1800000
	const idleTimer = useIdleTimerContext()
	const [isIdle, setIsIdle] = useState(false)

	useEffect(() => {
		let timeoutLogout = setTimeout(() => {
			if (isIdle) {
				UserHelper._shared().doLogout()
			}
		}, logoutTime)

		return () => {
			clearTimeout(timeoutLogout)
		}
	}, [isIdle])

	const onPrompt = () => {
		// Fire a Modal Prompt
	}

	const onIdle = () => {
		// Close Modal Prompt
		// Do some idle action like log out your user
		// console.log(TAG)
		// console.log(providerName, STATUS.IDLE)

		Analytics._sendAnalyticsLinkEvent('Account', 'Inactivity')
		setIsIdle(true)
		if (idleTimer) {
			// console.log('IDLE TAB', idleTimer.getTabId())
		}
	}

	const onActive = (event) => {
		// Close Modal Prompt
		// Do some active action
		// console.log(TAG)
		// console.log(providerName, STATUS.ACTIVE)
		setIsIdle(false)
	}

	const onAction = (event) => {
		// Do something when a user triggers a watched event
	}

	return (
		<IdleTimerProvider
			timeout={timeout}
			onPrompt={onPrompt}
			onIdle={onIdle}
			onActive={onActive}
			onAction={onAction}
			onMessage={() => {}}
			syncTimers={300}
			name={providerName}
			timers={workerTimers}
			crossTab>
			{children}
		</IdleTimerProvider>
	)
}
